import React from 'react';

import * as styles from './styles';
import { DrawerHeader } from './DrawerHeader/DrawerHeader';
import moment from 'moment';

import type { Checklist, ChecklistField } from '@cobliteam/api-lib';

import { Analytics } from '@cobliteam/analytics';

import {
  CaptionDefault,
  Divider,
  Drawer,
  InfoIcon,
} from '@cobliteam/base-components';

import { DRAWER_WIDTH } from '../ChecklistDrawer/styles';
import { ChecklistReceivedItem } from '../ChecklistReceivedItem/ChecklistReceivedItem';

export interface ChecklistReceivedDrawerProps {
  selectedChecklist: Checklist;
  open: boolean;
  onCloseDrawer: () => void;
}

export const ChecklistReceivedDrawer: React.FC<ChecklistReceivedDrawerProps> =
  ({ open, onCloseDrawer, selectedChecklist }) => {
    const { name, context, createdBy, createdAt, fields } = selectedChecklist;

    const handleCloseDrawer = () => {
      Analytics.track('Checklist Drawer Closed');

      onCloseDrawer();
    };

    return (
      <Drawer
        open={open}
        closeOnClickOutside
        title={name}
        header={
          <DrawerHeader
            vehicle={context?.vehicle || undefined}
            createdBy={createdBy}
          />
        }
        body={
          <div className={styles.body}>
            {fields?.map((item: ChecklistField, index: number) => (
              <React.Fragment key={index}>
                <div className={styles.checklistReceivedItem}>
                  <ChecklistReceivedItem
                    required={item.required}
                    content={item.content}
                    title={item.title}
                    type={item.type}
                  />
                </div>
                <Divider />
              </React.Fragment>
            ))}
            {createdAt && (
              <div className={styles.bodyTip}>
                <InfoIcon className={styles.bodyTipIcon} />
                <CaptionDefault>
                  Informações fornecidas e enviadas pelo remetente em
                  <b>{` ${moment(createdAt).format('DD/MM')} às `}</b>
                  <b>{moment(createdAt).format('HH:mm')}</b>
                </CaptionDefault>
              </div>
            )}
          </div>
        }
        onClose={handleCloseDrawer}
        customWidth={DRAWER_WIDTH}
      />
    );
  };

export default ChecklistReceivedDrawer;
